<div class="doc-editor-container" [dir]="'ltr'">
  <div>
    <div class="doc-editor-header">
      <div class="header-actions" *ngIf="showActions">
        <span *ngIf="allowSaveAsPdf">
          <button  class="action-container" (click)="saveAsPdf()">
            <i class="bi bi-file-earmark-binary" matTooltip="Save as PDF"></i>
            <div class="action-title">Save as PDF</div>
          </button>
        </span>
        <span>
          <button  class="action-container" (click)="close()">
            <i class="bi bi-save" matTooltip="Save"></i>
            <div class="action-title">Save</div>
          </button>
        </span>
        <!-- <span *ngIf="allowSaveAsPdf">
          <button  class="action-container" (click)="performAction('SAVE_AS_PDF')">
            <i class="bi bi-file-earmark-binary" matTooltip="Save as PDF"></i>
            <div class="action-title">Template PDF</div>
          </button>
        </span>
        <span *ngIf="allowSaveAsPdf">
          <button  class="action-container" (click)="performAction('PREVIEW_AS_PDF')">
            <i class="bi bi-file-earmark-binary-fill" matTooltip="Download processed as PDF"></i>
            <div class="action-title">Result PDF</div>
          </button>
        </span>
        <span *ngIf="allowSaveAsDocx">
          <button class="action-container" (click)="performAction('SAVE_AS_DOCX')">
            <i class="bi bi-file-word" matTooltip="Download current odt version"></i>
            <div class="action-title">Template Doc</div>
          </button>
        </span>
        <span  *ngIf="allowSaveAsDocx">
          <button class="action-container" (click)="performAction('PREVIEW_AS_DOCX')">
            <i class="bi bi-file-word-fill" matTooltip="Download processed odt version"></i>
            <div class="action-title">Result Doc</div>
          </button>
        </span>
        <span  *ngIf="allowSaveAsBase64">
          <button class="action-container" (click)="performAction('SAVE_AS_BASE64')">
            <i class="bi bi-file-code" matTooltip="Download docx as base64"></i>
            <div class="action-title">Template Base64</div>
          </button>
        </span>
        <span  *ngIf="allowSaveAsBase64">
          <button class="action-container" (click)="performAction('PREVIEW_AS_BASE64')">
            <i class="bi bi-file-code-fill" matTooltip="Download processed docx version"></i>
            <div class="action-title">Result Base64</div>
          </button>
        </span> -->
      </div>
      <span style="display: flex;
                    width: 421px;
                    flex-direction: row-reverse;">

        <button class="p-button-text p-button p-component" (click)="close()">
          <!-- <mat-icon class="text-red-500">close</mat-icon> -->
          <span  class="bi bi-x"></span>
        </button>
        <button class="p-button-text p-button p-component" (click)="toggleSideMenu()">
          <!-- <mat-icon class="text-red-500">close</mat-icon> -->
          <span  class="bi bi-layout-sidebar-inset-reverse" [ngStyle]="{color: hideSideMenu ? 'gray': '#1a96c6'}"></span>
        </button>
      </span>
    </div>

    <div class="doc-editor-loader">
      <mat-progress-bar *ngIf="loading || saving" mode="buffer"></mat-progress-bar>
    </div>
  </div>
  <div class="doc-editor-wrapper" [ngClass]="{'hide-menu-editor' : hideSideMenu}">

    <div class="doc-editor-panel">
      <div style="display: none">
        <form #form ngNoForm  action="{{wopiUrl}}" enctype="multipart/form-data" method="post" target="collabora-online-viewer" id="collabora-submit-form">
          <input name="access_token" value="{{accessToken}}" type="hidden" id="access-token"/>
          <input type="submit" value="" />
        </form>
      </div>
      <iframe id="collabora-online-viewer" name="collabora-online-viewer"
              style="display:block;height: 100%; width: 100%">
      </iframe>
    </div>
    <div class="side-tabs-container-editor">
      <lib-document-editor-sidebar #editorSidebar [hidden]="!template" [template]="template"></lib-document-editor-sidebar>
    </div>
  </div>
</div>
